/**
 * FUELED Subscription Builder
 * Bugs corrigés:
 * - Double écriture dans updateRecap() + référence discountEl inexistante
 * - Doublon toggleMealSelection / toggleMealSelectionNew → unifié en toggleMealSelectionNew
 * - Doublon updateMealQuantityDisplay / updateMealQtyDisplay → unifié en updateMealQtyDisplay
 * - renderMeals() + filterMealsByCategory() → code mort supprimé (rendu en Liquid)
 * - Classics/Bagels data-meal-id manquant → corrections dans le Liquid
 * - Solo: selectedMeals synchronisé via setCurrentPersonMeals
 */

(function() {
  'use strict';

  var CONFIG = {
    totalSteps: 7,
    animationDuration: 300
  };

  var state = {
    currentStep: 0,
    postalCode: null,
    zone: null,
    orderType: null,
    portion: null,
    portion1: null,
    portion2: null,
    mealsCount: null,
    // selectedMeals = alias de selectedMealsPerson1 en solo pour simplifier
    selectedMeals: [],
    selectedMealsPerson1: [],
    selectedMealsPerson2: [],
    currentPerson: 1,
    deliveryDay: null,
    totalPrice: 0
  };

  var postalData = {};
  var pricingData = {};

  // =========================================
  // INIT
  // =========================================
  function init() {
    loadData();
    initPostalCheck();
    initWaitlistForm();
    initOptionButtons();
    initNavigation();
    initProgressSteps();
    initTabs();
    initDeliveryDays();
    initSubmit();
    initNewsletterRecap();
    initPersonTabs();
    initNextPersonButton();
    initResetButton();
    initInfoButtons();
    console.log('FUELED Subscribe Builder initialized');
  }

  function loadData() {
    try {
      var postalEl = document.getElementById('fueled-postal-data');
      var pricingEl = document.getElementById('fueled-pricing-data');
      var mealsEl = document.getElementById('fueled-meals-data');
      if (postalEl) postalData = JSON.parse(postalEl.textContent);
      if (pricingEl) pricingData = JSON.parse(pricingEl.textContent);
      if (mealsEl) window.fueledMeals = JSON.parse(mealsEl.textContent);
    } catch (e) {
      console.error('Error loading data:', e);
    }
  }

  // =========================================
  // CODE POSTAL
  // =========================================
  function initPostalCheck() {
    var input = document.getElementById('postal-code');
    var btn = document.getElementById('check-postal');
    if (!input || !btn) return;
    btn.addEventListener('click', checkPostalCode);
    input.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); checkPostalCode(); }
    });
    input.addEventListener('input', function(e) {
      e.target.value = e.target.value.replace(/[^0-9]/g, '');
    });
  }

  function checkPostalCode() {
    var input = document.getElementById('postal-code');
    var resultEl = document.getElementById('postal-result');
    var waitlistEl = document.getElementById('postal-waitlist');
    var code = parseInt(input.value, 10);

    if (!input.value || input.value.length < 4) {
      showResult(resultEl, "Merci d'entrer un code postal valide (4 chiffres)", 'error');
      return;
    }

    var foundZone = null;
    for (var zoneName in postalData) {
      if (postalData.hasOwnProperty(zoneName)) {
        var zoneData = postalData[zoneName];
        if (zoneData.codes && zoneData.codes.indexOf(code) !== -1) {
          foundZone = { name: zoneName, days: zoneData.days, timeSlot: zoneData.timeSlot };
          break;
        }
      }
    }

    if (foundZone) {
      state.postalCode = code;
      state.zone = foundZone;
      // days is array of objects {label, value, slot}
      var dayLabels = foundZone.days.map(function(d) { return typeof d === 'object' ? d.label : d; }).join(' ou ');
      var firstDay = foundZone.days[0];
      var slotStr = firstDay && typeof firstDay === 'object' ? firstDay.slot : (foundZone.timeSlot || '');
      showResult(resultEl, '🎉 Super ! On livre chez toi (' + dayLabels + (slotStr ? ', ' + slotStr : '') + ')', 'success');
      waitlistEl.style.display = 'none';
      enableNextButton();
    } else {
      state.postalCode = null;
      state.zone = null;
      showResult(resultEl, "😢 Désolé, on ne livre pas encore dans ta zone...", 'error');
      waitlistEl.style.display = 'block';
      document.getElementById('waitlist-postal').value = code;
      disableNextButton();
    }
  }

  function showResult(el, message, type) {
    el.textContent = message;
    el.className = 'fueled-postal__result ' + type;
    el.style.display = 'block';
  }

  function initWaitlistForm() {
    var form = document.getElementById('waitlist-form');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = document.getElementById('waitlist-email').value.trim();
      var postal = document.getElementById('waitlist-postal').value.trim();
      var btn = form.querySelector('button[type="submit"]');

      if (!email) return;

      btn.disabled = true;
      btn.textContent = 'Envoi...';

      // Inscription via Shopify /contact (newsletter) avec tag zone
      // Les données arrivent dans Shopify Admin → Clients → tag "waitlist-XXXX"
      var formData = new FormData();
      formData.append('form_type', 'customer');
      formData.append('utf8', '✓');
      formData.append('customer[email]', email);
      formData.append('customer[tags]', 'waitlist,' + 'waitlist-' + postal);
      formData.append('customer[note]', 'Waitlist livraison - Code postal: ' + postal);
      formData.append('contact[email]', email);
      formData.append('contact[body]', 'Waitlist livraison - Code postal: ' + postal);

      // On envoie vers /contact pour capturer l'email même sans compte client
      var contactData = new URLSearchParams();
      contactData.append('form_type', 'contact');
      contactData.append('utf8', '✓');
      contactData.append('contact[email]', email);
      contactData.append('contact[name]', 'Waitlist ' + postal);
      contactData.append('contact[body]', 'Nouvelle inscription waitlist livraison. Code postal : ' + postal);

      fetch('/contact#contact_form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: contactData.toString()
      })
      .then(function() {
        // Succès ou pas, on confirme toujours (Shopify peut renvoyer 200 même en cas de doublon)
        form.style.display = 'none';
        document.getElementById('waitlist-success').style.display = 'block';
      })
      .catch(function() {
        // Fallback : on confirme quand même visuellement
        form.style.display = 'none';
        document.getElementById('waitlist-success').style.display = 'block';
      });
    });
  }

  // =========================================
  // OPTIONS BUTTONS
  // =========================================
  function initOptionButtons() {
    var buttons = document.querySelectorAll('.fueled-option[data-field]');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var field = btn.dataset.field;
        var value = btn.dataset.value;
        // Désélectionner dans le même groupe
        var parent = btn.closest('.fueled-options') || btn.closest('.fueled-duo-person');
        if (parent) {
          parent.querySelectorAll('.fueled-option').forEach(function(b) {
            b.classList.remove('selected');
            b.classList.remove('fueled-option--confirmed');
          });
        }
        btn.classList.add('selected');
        state[field] = value;
        handleFieldChange(field, value);
        validateCurrentStep();
        // Auto-avance vers l'étape suivante après sélection
        // Exclure: étape 0 (gérée par le code postal), étape 4 (sélection multiple de plats)
        if (state.currentStep !== 0 && state.currentStep !== 4) {
          // Confirmation visuelle (coche animée) puis avance en douceur
          btn.classList.add('fueled-option--confirmed');
          setTimeout(function() {
            if (validateCurrentStep()) {
              goToStep(state.currentStep + 1);
            }
          }, 900);
        }
      });
    });
  }

  function handleFieldChange(field, value) {
    if (field === 'orderType') {
      var soloEl = document.getElementById('portion-solo');
      var duoEl = document.getElementById('portion-duo');
      var mealsOptions = document.querySelector('.fueled-options--meals');
      if (value === 'duo') {
        soloEl.style.display = 'none';
        duoEl.style.display = 'block';
        document.getElementById('portion-subtitle').textContent = 'Choisis la portion pour chaque personne';
        if (mealsOptions) mealsOptions.classList.add('duo-mode');
      } else {
        soloEl.style.display = 'block';
        duoEl.style.display = 'none';
        document.getElementById('portion-subtitle').textContent = 'Choisis selon ton appétit et tes objectifs';
        if (mealsOptions) mealsOptions.classList.remove('duo-mode');
      }
      state.portion = null;
      state.portion1 = null;
      state.portion2 = null;
    } else if (field === 'mealsCount') {
      resetMealSelections();
      updateMealsCounterForCurrentPerson();
    } else if (field === 'portion' || field === 'portion1' || field === 'portion2') {
      updateMacrosForSize();
    }
  }

  // =========================================
  // NAVIGATION
  // =========================================
  function initNavigation() {
    var prevBtn = document.getElementById('prev-step');
    var nextBtn = document.getElementById('next-step');
    if (prevBtn) prevBtn.addEventListener('click', function() { goToStep(state.currentStep - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goToStep(state.currentStep + 1); });
  }

  function goToStep(stepIndex) {
    if (stepIndex < 0 || stepIndex > CONFIG.totalSteps - 1) return;
    var currentStepEl = document.querySelector('.fueled-step[data-step="' + state.currentStep + '"]');
    if (currentStepEl) currentStepEl.classList.remove('active');
    var newStepEl = document.querySelector('.fueled-step[data-step="' + stepIndex + '"]');
    if (newStepEl) newStepEl.classList.add('active');
    updateProgressBar(stepIndex);
    state.currentStep = stepIndex;
    updateNavigation();
    onStepEnter(stepIndex);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function updateProgressBar(stepIndex) {
    var steps = document.querySelectorAll('.fueled-progress__step');
    steps.forEach(function(el, i) {
      el.classList.remove('active', 'completed');
      if (i < stepIndex) el.classList.add('completed');
      else if (i === stepIndex) el.classList.add('active');
    });
    var fill = document.querySelector('.fueled-progress__fill');
    if (fill) fill.style.width = ((stepIndex + 1) / CONFIG.totalSteps * 100) + '%';
  }

  function updateNavigation() {
    var nav = document.getElementById('fueled-nav');
    var prevBtn = document.getElementById('prev-step');
    var nextBtn = document.getElementById('next-step');
    // Cacher nav sur étape 0 et dernière étape (récap)
    if (nav) nav.style.display = (state.currentStep === CONFIG.totalSteps - 1) ? 'none' : 'flex';
    if (prevBtn) {
      prevBtn.style.display = state.currentStep > 0 ? 'flex' : 'none';
    }
    if (nextBtn) {
      // En duo étape plats personne 1, cacher "Continuer" (on passe via le bouton dédié)
      if (state.currentStep === 4 && state.orderType === 'duo' && state.currentPerson === 1) {
        nextBtn.style.display = 'none';
      } else {
        nextBtn.style.display = 'flex';
        nextBtn.textContent = state.currentStep === CONFIG.totalSteps - 2 ? 'Voir le récap →' : 'Continuer →';
      }
    }
    validateCurrentStep();
  }

  function initProgressSteps() {
    document.querySelectorAll('.fueled-progress__step').forEach(function(step) {
      step.addEventListener('click', function() {
        if (step.classList.contains('completed') || step.classList.contains('active')) {
          goToStep(parseInt(step.dataset.step, 10));
        }
      });
    });
  }

  function onStepEnter(stepIndex) {
    if (stepIndex === 3) {
      updatePriceDisplay();
    } else if (stepIndex === 4) {
      setupMealsStep();
      loadMeals();
      restoreMealSelections();
      updateMealPricesDisplay();
    } else if (stepIndex === 5) {
      var deliveryPostalEl = document.getElementById('delivery-postal');
      if (deliveryPostalEl) deliveryPostalEl.textContent = state.postalCode;
      renderDeliveryDays();
    } else if (stepIndex === 6) {
      updateRecap();
    }
  }

  // =========================================
  // VALIDATION
  // =========================================
  function validateCurrentStep() {
    var isValid = false;
    var mealsCount = parseInt(state.mealsCount, 10);

    switch (state.currentStep) {
      case 0: isValid = state.postalCode !== null && state.zone !== null; break;
      case 1: isValid = state.orderType !== null; break;
      case 2:
        isValid = state.orderType === 'solo'
          ? state.portion !== null
          : state.portion1 !== null && state.portion2 !== null;
        break;
      case 3: isValid = state.mealsCount !== null; break;
      case 4:
        isValid = state.orderType === 'duo'
          ? state.selectedMealsPerson1.length >= mealsCount && state.selectedMealsPerson2.length >= mealsCount
          : state.selectedMeals.length >= mealsCount;
        break;
      case 5: isValid = state.deliveryDay !== null; break;
      default: isValid = true;
    }

    if (isValid) enableNextButton(); else disableNextButton();
    return isValid;
  }

  function enableNextButton() {
    var btn = document.getElementById('next-step');
    if (btn) btn.disabled = false;
    // Sur l'étape 0 (Zone), afficher la nav avec uniquement le bouton Continuer
    if (state.currentStep === 0) {
      var nav = document.getElementById('fueled-nav');
      if (nav) nav.style.display = 'flex';
      var prevBtn = document.getElementById('prev-step');
      if (prevBtn) prevBtn.style.display = 'none';
    }
  }

  function disableNextButton() {
    var btn = document.getElementById('next-step');
    if (btn) btn.disabled = true;
  }

  // =========================================
  // ÉTAPE 3 - PRIX AFFICHÉS
  // =========================================
  function updatePriceDisplay() {
    // Les prix par plat sont déjà affichés dans le Liquid (8,50€/plat Light)
    // En mode duo, on peut afficher ×2 sous chaque option
    var isDuo = state.orderType === 'duo';
    ['price-3','price-5','price-7'].forEach(function(id) {
      var el = document.getElementById(id);
      if (!el) return;
      // Préserver le contenu Liquid, juste ajouter ×2 si duo
      var small = el.querySelector('small');
      if (small) {
        small.textContent = isDuo ? '/plat × 2 pers.' : '/plat';
      }
    });
  }

  // =========================================
  // ÉTAPE 4 - SÉLECTION DES PLATS
  // =========================================
  // =========================================
  // PRIX PAR PLAT sur les cartes (identique à account)
  // =========================================
  function updateMealPricesDisplay() {
    var portion = state.portion || state.portion1 || 'daily';
    var prices = { light: 11.90, daily: 12.90, boost: 13.90 };

    document.querySelectorAll('.fueled-meal-wrapper').forEach(function(wrapper) {
      var priceEl = wrapper.querySelector('.fueled-meal-price');
      if (!priceEl) return;

      var amountEl = priceEl.querySelector('.fueled-meal-price__amount');
      if (!amountEl) return;

      var basePrice;
      var fixed = priceEl.dataset.priceFixed;
      if (fixed) {
        basePrice = parseFloat(fixed);
      } else {
        basePrice = prices[portion] || 12.90;
      }

      var discounted = basePrice * 0.95;
      var baseFmt = (basePrice % 1 === 0 ? basePrice : basePrice.toFixed(2)).toString().replace('.', ',');
      var discFmt = discounted.toFixed(2).replace('.', ',');
      amountEl.innerHTML = '<s>' + baseFmt + '€</s> ' + discFmt + '€';
    });
  }

  function setupMealsStep() {
    var personIndicator = document.getElementById('person-indicator');
    var nextPersonContainer = document.getElementById('next-person-container');
    var currentPersonLabel = document.getElementById('current-person-label');
    var mealsToSelect = document.getElementById('meals-to-select');

    if (state.orderType === 'duo') {
      if (personIndicator) personIndicator.style.display = 'block';
      state.currentPerson = 1;
      var portion1Label = document.getElementById('person1-portion-label');
      var portion2Label = document.getElementById('person2-portion-label');
      if (portion1Label) portion1Label.textContent = formatPortionShort(state.portion1);
      if (portion2Label) portion2Label.textContent = formatPortionShort(state.portion2);
      updatePersonTabs();
      if (currentPersonLabel) currentPersonLabel.textContent = 'Pour la Personne 1, choisis';
    } else {
      if (personIndicator) personIndicator.style.display = 'none';
      if (nextPersonContainer) nextPersonContainer.style.display = 'none';
      if (currentPersonLabel) currentPersonLabel.textContent = 'Choisis';
    }

    var mealsCount = parseInt(state.mealsCount, 10);
    if (mealsToSelect) mealsToSelect.textContent = mealsCount;
    updateMealsCounterForCurrentPerson();
  }

  function loadMeals() {
    // Plats rendus en Liquid — on attache juste les événements de clic
    initMealClicks();
    updateMacrosForSize();
  }

  function initMealClicks() {
    document.querySelectorAll('.fueled-meal-wrapper').forEach(function(wrapper) {
      // Éviter double-binding
      var clone = wrapper.cloneNode(true);
      wrapper.parentNode.replaceChild(clone, wrapper);
    });
    document.querySelectorAll('.fueled-meal-wrapper').forEach(function(wrapper) {
      wrapper.addEventListener('click', function(e) {
        if (e.target.closest('.fueled-meal-info-btn') || e.target.closest('.fueled-meal-macros')) return;
        e.preventDefault();
        e.stopPropagation();
        toggleMealSelectionNew(wrapper);
      });
    });
    // Ré-initialiser les boutons info après cloneNode
    initInfoButtons();
  }

  function toggleMealSelectionNew(wrapper) {
    var mealId = parseInt(wrapper.dataset.mealId, 10);
    if (isNaN(mealId)) return;
    var category = wrapper.dataset.category;
    var mealName = wrapper.dataset.mealName;
    var mealsCount = parseInt(state.mealsCount, 10);

    var currentMeals = getCurrentPersonMeals();
    var currentCount = currentMeals.filter(function(m) { return m.id === mealId; }).length;
    var totalSelected = currentMeals.length;

    if (currentCount === 0 && totalSelected < mealsCount) {
      currentMeals.push({ id: mealId, name: mealName, category: category });
      wrapper.classList.add('selected');
      updateMealQtyDisplay(wrapper, 1);
    } else if (currentCount > 0 && totalSelected < mealsCount && currentCount < 3) {
      currentMeals.push({ id: mealId, name: mealName, category: category });
      updateMealQtyDisplay(wrapper, currentCount + 1);
    } else if (currentCount > 0) {
      // Retirer une occurrence
      var index = -1;
      for (var i = 0; i < currentMeals.length; i++) {
        if (currentMeals[i].id === mealId) { index = i; break; }
      }
      if (index > -1) currentMeals.splice(index, 1);
      var newCount = currentMeals.filter(function(m) { return m.id === mealId; }).length;
      if (newCount === 0) wrapper.classList.remove('selected');
      updateMealQtyDisplay(wrapper, newCount);
    } else if (totalSelected >= mealsCount) {
      // Limite atteinte — feedback visuel
      wrapper.classList.add('fueled-meal-wrapper--shake');
      setTimeout(function() { wrapper.classList.remove('fueled-meal-wrapper--shake'); }, 400);
      return;
    }

    setCurrentPersonMeals(currentMeals);
    updateMealsCounterDisplay();
    if (state.orderType === 'duo') updatePersonTabs();
    validateCurrentStep();
    updateNavigation();
  }

  function updateMealQtyDisplay(wrapper, count) {
    var qtyEl = wrapper.querySelector('.fueled-meal-qty');
    if (qtyEl) qtyEl.textContent = count > 1 ? 'x' + count : '';
  }

  function restoreMealSelections() {
    var currentMeals = getCurrentPersonMeals();
    document.querySelectorAll('.fueled-meal-wrapper').forEach(function(wrapper) {
      wrapper.classList.remove('selected');
      var qtyEl = wrapper.querySelector('.fueled-meal-qty');
      if (qtyEl) qtyEl.textContent = '';
    });
    currentMeals.forEach(function(meal) {
      var wrapper = document.querySelector('.fueled-meal-wrapper[data-meal-id="' + meal.id + '"]');
      if (wrapper) {
        wrapper.classList.add('selected');
        var count = currentMeals.filter(function(m) { return m.id === meal.id; }).length;
        updateMealQtyDisplay(wrapper, count);
      }
    });
  }

  function getCurrentPersonMeals() {
    if (state.orderType === 'duo') {
      return state.currentPerson === 1 ? state.selectedMealsPerson1 : state.selectedMealsPerson2;
    }
    return state.selectedMeals;
  }

  function setCurrentPersonMeals(meals) {
    if (state.orderType === 'duo') {
      if (state.currentPerson === 1) state.selectedMealsPerson1 = meals;
      else state.selectedMealsPerson2 = meals;
    } else {
      state.selectedMeals = meals;
    }
  }

  function resetMealSelections() {
    state.selectedMeals = [];
    state.selectedMealsPerson1 = [];
    state.selectedMealsPerson2 = [];
    state.currentPerson = 1;
    document.querySelectorAll('.fueled-meal-wrapper').forEach(function(wrapper) {
      wrapper.classList.remove('selected');
      var qtyEl = wrapper.querySelector('.fueled-meal-qty');
      if (qtyEl) qtyEl.textContent = '';
    });
  }

  // =========================================
  // COMPTEURS ET SIDEBAR
  // =========================================
  function updateMealsCounterForCurrentPerson() {
    var mealsCount = parseInt(state.mealsCount, 10);
    var toSelectEl = document.getElementById('meals-to-select');
    var totalCountEl = document.getElementById('total-count');
    if (toSelectEl) toSelectEl.textContent = mealsCount;
    if (totalCountEl) totalCountEl.textContent = mealsCount;
    updateMealsCounterDisplay();
  }

  function updateMealsCounterDisplay() {
    var mealsCount = parseInt(state.mealsCount, 10);
    var totalSelected = getCurrentPersonMeals().length;

    document.querySelectorAll('#selected-count, .fueled-sidebar-count-current').forEach(function(el) {
      el.textContent = totalSelected;
    });

    var resetBtn = document.getElementById('reset-meals');
    if (resetBtn) resetBtn.style.display = totalSelected > 0 ? 'inline-block' : 'none';

    updateAllMealBadges();
    updateSidebarSelectedList();
    updateSidebarPrice();
  }

  function updateAllMealBadges() {
    var currentMeals = getCurrentPersonMeals();
    document.querySelectorAll('.fueled-meal-wrapper').forEach(function(wrapper) {
      var mealId = parseInt(wrapper.dataset.mealId, 10);
      var count = currentMeals.filter(function(m) { return m.id === mealId; }).length;
      if (count > 0) {
        wrapper.classList.add('selected');
        var qtyEl = wrapper.querySelector('.fueled-meal-qty');
        if (qtyEl) qtyEl.textContent = 'x' + count;
      } else {
        wrapper.classList.remove('selected');
        var qtyEl2 = wrapper.querySelector('.fueled-meal-qty');
        if (qtyEl2) qtyEl2.textContent = '';
      }
    });
  }

  function updateSidebarSelectedList() {
    var listEl = document.getElementById('sidebar-selected-list');
    if (!listEl) return;
    var currentMeals = getCurrentPersonMeals();

    if (currentMeals.length === 0) {
      listEl.innerHTML = '<p class="fueled-sidebar-empty">Aucun plat sélectionné</p>';
      return;
    }

    var grouped = {};
    currentMeals.forEach(function(meal) {
      if (!grouped[meal.id]) grouped[meal.id] = { name: meal.name, count: 0 };
      grouped[meal.id].count++;
    });

    var html = '';
    Object.keys(grouped).forEach(function(id) {
      var meal = grouped[id];
      var displayName = meal.count > 1 ? meal.name + ' (x' + meal.count + ')' : meal.name;
      html += '<div class="fueled-sidebar-selected-item" data-meal-id="' + id + '">';
      html += '<span class="fueled-sidebar-selected-item-name">' + displayName + '</span>';
      html += '<button type="button" class="fueled-sidebar-selected-item-remove" data-meal-id="' + id + '">×</button>';
      html += '</div>';
    });
    listEl.innerHTML = html;

    listEl.querySelectorAll('.fueled-sidebar-selected-item-remove').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        removeMealFromSelection(parseInt(btn.dataset.mealId, 10));
      });
    });
  }

  function removeMealFromSelection(mealId) {
    var currentMeals = getCurrentPersonMeals();
    var index = -1;
    for (var i = 0; i < currentMeals.length; i++) {
      if (currentMeals[i].id === mealId) { index = i; break; }
    }
    if (index > -1) {
      currentMeals.splice(index, 1);
      setCurrentPersonMeals(currentMeals);
      var wrapper = document.querySelector('.fueled-meal-wrapper[data-meal-id="' + mealId + '"]');
      if (wrapper) {
        var remaining = currentMeals.filter(function(m) { return m.id === mealId; }).length;
        if (remaining === 0) wrapper.classList.remove('selected');
        updateMealQtyDisplay(wrapper, remaining);
      }
      updateMealsCounterDisplay();
      if (state.orderType === 'duo') updatePersonTabs();
      validateCurrentStep();
      updateNavigation();
    }
  }

  function updateSidebarPrice() {
    var priceOriginalEl = document.getElementById('sidebar-price-original');
    var priceDiscountedEl = document.getElementById('sidebar-price-discounted');
    var sidebarTypeEl = document.getElementById('sidebar-type');
    var sidebarPortionEl = document.getElementById('sidebar-portion');
    var sidebarMealsEl = document.getElementById('sidebar-meals');
    var badge = document.querySelector('.fueled-sidebar-price-badge');

    var totalOriginal = calculateTotalPrice();
    var totalDiscounted = totalOriginal * 0.95;

    if (priceOriginalEl) {
      priceOriginalEl.textContent = totalOriginal.toFixed(2).replace('.', ',') + '€';
      priceOriginalEl.style.display = totalOriginal > 0 ? 'block' : 'none';
    }
    if (priceDiscountedEl) {
      priceDiscountedEl.textContent = totalOriginal > 0
        ? totalDiscounted.toFixed(2).replace('.', ',') + '€'
        : '0,00€';
    }
    if (badge) {
      badge.style.display = totalOriginal > 0 ? 'inline-block' : 'none';
      badge.textContent = '-5%';
    }

    if (sidebarTypeEl) sidebarTypeEl.textContent = state.orderType === 'duo' ? 'Duo' : 'Solo';
    if (sidebarPortionEl) {
      var p = state.portion || state.portion1 || 'daily';
      sidebarPortionEl.textContent = p.charAt(0).toUpperCase() + p.slice(1);
    }
    if (sidebarMealsEl) sidebarMealsEl.textContent = state.mealsCount || '5';
  }

  // =========================================
  // PRIX
  // =========================================
  function calculateTotalPrice() {
    var total = 0;
    if (state.orderType === 'duo') {
      state.selectedMealsPerson1.forEach(function(meal) {
        total += getMealPrice(meal.category, state.portion1);
      });
      state.selectedMealsPerson2.forEach(function(meal) {
        total += getMealPrice(meal.category, state.portion2);
      });
    } else {
      state.selectedMeals.forEach(function(meal) {
        total += getMealPrice(meal.category, state.portion);
      });
    }
    state.totalPrice = total;
    return total;
  }

  function getMealPrice(category, portion) {
    if (category === 'menu') {
      if (portion === 'light') return 11.90;
      if (portion === 'boost') return 13.90;
      return 12.90; // daily
    }
    if (category === 'classics') return 11.90;
    if (category === 'bagels') return 8.90;
    return 12.90;
  }

  // =========================================
  // MACROS
  // =========================================
  function updateMacrosForSize() {
    var portionSize = state.orderType === 'duo'
      ? (state.currentPerson === 1 ? state.portion1 : state.portion2)
      : state.portion;
    portionSize = (portionSize || 'daily').toLowerCase();

    document.querySelectorAll('.fueled-meal-wrapper[data-has-variants="true"]').forEach(function(wrapper) {
      var macrosJson = wrapper.querySelector('.fueled-variant-macros');
      var macrosDisplay = wrapper.querySelector('.fueled-meal-macros');
      if (!macrosJson || !macrosDisplay) return;
      try {
        var allMacros = JSON.parse(macrosJson.textContent);
        var macros = allMacros[portionSize];
        if (macros) {
          var calEl = macrosDisplay.querySelector('.fueled-meal-macros__calories');
          if (calEl) calEl.textContent = macros.calories + ' kcal';
          var values = macrosDisplay.querySelectorAll('.fueled-meal-macro__value');
          if (values[0]) values[0].textContent = macros.proteines + 'g';
          if (values[1]) values[1].textContent = macros.glucides + 'g';
          if (values[2]) values[2].textContent = macros.lipides + 'g';
        }
      } catch (e) {
        console.error('Erreur parsing macros:', e);
      }
    });
  }

  // =========================================
  // BOUTON INFO (MACROS TOGGLE MOBILE)
  // =========================================
  function initInfoButtons() {
    document.querySelectorAll('.fueled-meal-info-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('.fueled-meal-card');
        var macros = card ? card.querySelector('.fueled-meal-macros') : null;
        document.querySelectorAll('.fueled-meal-macros.active').forEach(function(m) {
          if (m !== macros) m.classList.remove('active');
        });
        if (macros) macros.classList.toggle('active');
      });
    });
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.fueled-meal-info-btn') && !e.target.closest('.fueled-meal-macros')) {
        document.querySelectorAll('.fueled-meal-macros.active').forEach(function(m) {
          m.classList.remove('active');
        });
      }
    });
  }

  // =========================================
  // TABS CATÉGORIES
  // =========================================
  function initTabs() {
    var tabs = document.querySelectorAll('.fueled-tab');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var category = tab.dataset.category;
        document.querySelectorAll('.fueled-meals-grid').forEach(function(grid) {
          grid.style.display = 'none';
        });
        var targetGrid = document.getElementById('meals-' + category);
        if (targetGrid) targetGrid.style.display = 'block';
        updateMacrosForSize();
        restoreMealSelections();
        updateMealPricesDisplay();
      });
    });
  }

  // =========================================
  // RESET
  // =========================================
  function initResetButton() {
    var resetBtn = document.getElementById('reset-meals');
    if (!resetBtn) return;
    resetBtn.addEventListener('click', function() {
      if (confirm('Effacer tous les plats sélectionnés ?')) {
        if (state.orderType === 'duo') {
          if (state.currentPerson === 1) state.selectedMealsPerson1 = [];
          else state.selectedMealsPerson2 = [];
        } else {
          state.selectedMeals = [];
        }
        updateAllMealBadges();
        updateMealsCounterDisplay();
        if (state.orderType === 'duo') updatePersonTabs();
        validateCurrentStep();
      }
    });
  }

  // =========================================
  // DUO - ONGLETS PERSONNE
  // =========================================
  function initPersonTabs() {
    document.addEventListener('click', function(e) {
      var tab = e.target.closest('.fueled-person-tab');
      if (tab) switchToPerson(parseInt(tab.dataset.person, 10));
    });
  }

  function switchToPerson(person) {
    state.currentPerson = person;
    updatePersonTabs();
    updateMealsCounterForCurrentPerson();
    var currentPersonLabel = document.getElementById('current-person-label');
    if (currentPersonLabel) currentPersonLabel.textContent = 'Pour la Personne ' + person + ', choisis';
    // Afficher onglet actif
    var activeTab = document.querySelector('.fueled-tab.active');
    var category = activeTab ? activeTab.dataset.category : 'menu';
    document.querySelectorAll('.fueled-meals-grid').forEach(function(g) { g.style.display = 'none'; });
    var targetGrid = document.getElementById('meals-' + category);
    if (targetGrid) targetGrid.style.display = 'block';
    updateMacrosForSize();
    restoreMealSelections();
    updateNavigation();
    validateCurrentStep();
  }

  function updatePersonTabs() {
    var tab1 = document.querySelector('.fueled-person-tab[data-person="1"]');
    var tab2 = document.querySelector('.fueled-person-tab[data-person="2"]');
    var status1 = document.getElementById('person1-status');
    var status2 = document.getElementById('person2-status');
    var nextPersonContainer = document.getElementById('next-person-container');
    var nextPersonBtn = document.getElementById('next-person-btn');
    var mealsCount = parseInt(state.mealsCount, 10);
    var count1 = state.selectedMealsPerson1.length;
    var count2 = state.selectedMealsPerson2.length;

    if (status1) status1.textContent = count1 + '/' + mealsCount;
    if (status2) status2.textContent = count2 + '/' + mealsCount;

    if (tab1) {
      tab1.classList.toggle('active', state.currentPerson === 1);
      tab1.classList.toggle('complete', count1 >= mealsCount);
    }
    if (tab2) {
      tab2.classList.toggle('active', state.currentPerson === 2);
      tab2.classList.toggle('complete', count2 >= mealsCount);
    }

    if (nextPersonContainer && nextPersonBtn) {
      if (state.currentPerson === 1 && count1 >= mealsCount) {
        nextPersonContainer.style.display = 'block';
        nextPersonBtn.textContent = 'Passer aux plats de la Personne 2 →';
      } else if (state.currentPerson === 2 && count1 < mealsCount) {
        nextPersonContainer.style.display = 'block';
        nextPersonBtn.textContent = '← Retour aux plats de la Personne 1';
      } else {
        nextPersonContainer.style.display = 'none';
      }
    }
  }

  function initNextPersonButton() {
    document.addEventListener('click', function(e) {
      if (e.target.id === 'next-person-btn' || e.target.closest('#next-person-btn')) {
        switchToPerson(state.currentPerson === 1 ? 2 : 1);
      }
    });
  }

  // =========================================
  // LIVRAISON
  // =========================================
  function initDeliveryDays() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.fueled-option[data-field="deliveryDay"]');
      if (btn) {
        document.querySelectorAll('.fueled-option[data-field="deliveryDay"]').forEach(function(b) {
          b.classList.remove('selected');
        });
        btn.classList.add('selected');
        state.deliveryDay = btn.dataset.value;
        validateCurrentStep();
      }
    });
  }

  // Exception lundi de Pentecôte 25/05/2026 (férié) : on ajoute MARDI comme choix
  // supplémentaire pour les zones livrées en semaine (zoneA / zoneA_far / zoneA_both).
  // La garde porte sur la date du lundi calculé -> l'option disparaît seule la semaine suivante.
  function getPentecoteMardi() {
    var now = new Date(), dow = now.getDay(), h = now.getHours(), m = now.getMinutes();
    var late = (dow===5 && (h>23||(h===23&&m>=59))) || dow===6 || dow===0;
    var ds = (7-dow)%7 || (late ? 7 : 0);
    if (late && ds < 2) ds += 7;
    var sun = new Date(now); sun.setDate(now.getDate()+ds);
    var mon = new Date(sun); mon.setDate(sun.getDate()+1);
    if (mon.getFullYear()===2026 && mon.getMonth()===4 && mon.getDate()===25) {
      return { label:'Mardi', value:'mardi', slot:'9h – 16h' };
    }
    return null;
  }

  function renderDeliveryDays() {
    var container = document.getElementById('delivery-days');
    if (!container || !state.zone) return;
    // Jours = jours statiques de la zone (+ mardi si semaine de Pentecôte et zone
    // livrée en semaine). Copie locale utilisée pour le rendu ET le lookup du créneau.
    var days = (state.zone.days || []).slice();
    var weekdayZones = ['zoneA', 'zoneA_far', 'zoneA_both'];
    var mardi = getPentecoteMardi();
    if (mardi && weekdayZones.indexOf(state.zone.name) !== -1) days.push(mardi);
    var html = '';
    days.forEach(function(day) {
      // Support both old format (string) and new format (object with label/value/slot)
      var dayLabel = typeof day === 'object' ? day.label : day;
      var dayValue = typeof day === 'object' ? day.value : day.toLowerCase();
      var daySlot  = typeof day === 'object' ? day.slot  : (state.zone.timeSlot || '');
      html += '<button type="button" class="fueled-option" data-value="' + dayValue + '" data-field="deliveryDay">';
      html += '<span class="fueled-option__title">' + dayLabel + '</span>';
      html += '<span class="fueled-option__desc">🕙 ' + daySlot + '</span>';
      html += '</button>';
    });
    container.innerHTML = html;
    if (state.deliveryDay) {
      var selected = container.querySelector('[data-value="' + state.deliveryDay + '"]');
      if (selected) selected.classList.add('selected');
    }
    // Auto-avance après sélection du jour
    container.querySelectorAll('.fueled-option').forEach(function(btn) {
      btn.addEventListener('click', function() {
        // Confirmation visuelle (coche animée) sur le jour choisi
        container.querySelectorAll('.fueled-option--confirmed').forEach(function(b) {
          b.classList.remove('fueled-option--confirmed');
        });
        btn.classList.add('fueled-option--confirmed');
        // Store the slot for this day
        var dayValue = btn.dataset.value;
        var matchedDay = days.find(function(d) {
          return (typeof d === 'object' ? d.value : d.toLowerCase()) === dayValue;
        });
        state.deliverySlot = matchedDay && typeof matchedDay === 'object' ? matchedDay.slot : (state.zone.timeSlot || '');
        setTimeout(function() {
          if (validateCurrentStep()) {
            goToStep(state.currentStep + 1);
          }
        }, 900);
      });
    });
  }

  // =========================================
  // RÉCAPITULATIF — Bug corrigé (double écriture + discountEl manquant)
  // =========================================
  function updateRecap() {
    var typeEl = document.getElementById('recap-type');
    if (typeEl) typeEl.textContent = state.orderType === 'duo' ? 'En duo (2 personnes)' : 'Solo';

    var portionEl = document.getElementById('recap-portion');
    if (portionEl) {
      portionEl.textContent = state.orderType === 'duo'
        ? 'P1: ' + formatPortion(state.portion1) + ' / P2: ' + formatPortion(state.portion2)
        : formatPortion(state.portion);
    }

    var mealsEl = document.getElementById('recap-meals');
    if (mealsEl) {
      var total = state.orderType === 'duo' ? state.mealsCount * 2 : state.mealsCount;
      mealsEl.textContent = total + ' plats';
    }

    var postalEl = document.getElementById('recap-postal');
    if (postalEl) postalEl.textContent = state.postalCode;

    var dayEl = document.getElementById('recap-day');
    if (dayEl) dayEl.textContent = state.deliveryDay ? state.deliveryDay.charAt(0).toUpperCase() + state.deliveryDay.slice(1) : '';

    var dishesEl = document.getElementById('recap-dishes');
    if (dishesEl) {
      var html = '';
      if (state.orderType === 'duo') {
        html += '<li><strong>Personne 1 (' + formatPortionShort(state.portion1) + ') :</strong></li>';
        state.selectedMealsPerson1.forEach(function(meal) { html += '<li>' + meal.name + '</li>'; });
        html += '<li style="margin-top:10px;"><strong>Personne 2 (' + formatPortionShort(state.portion2) + ') :</strong></li>';
        state.selectedMealsPerson2.forEach(function(meal) { html += '<li>' + meal.name + '</li>'; });
      } else {
        state.selectedMeals.forEach(function(meal) { html += '<li>' + meal.name + '</li>'; });
      }
      dishesEl.innerHTML = html;
    }

    // Prix — une seule écriture propre
    var totalPrice = calculateTotalPrice();
    var deliveryFee = 6.90;
    var finalPrice = (totalPrice * 0.95) + deliveryFee; // -5% dès la 1ère semaine + livraison

    var totalEl = document.getElementById('recap-total');
    var finalEl = document.getElementById('recap-final');
    var nextWeeksEl = document.getElementById('recap-total-next');

    if (totalEl) totalEl.textContent = (totalPrice * 0.95).toFixed(2).replace('.', ',') + '€';
    if (finalEl) finalEl.textContent = finalPrice.toFixed(2).replace('.', ',') + '€';
    if (nextWeeksEl) nextWeeksEl.textContent = '';
  }

  // =========================================
  // FORMATAGE
  // =========================================
  function formatPortion(portion) {
    var map = { light: 'Light (400g)', daily: 'Daily (500g)', boost: 'Boost (600g)' };
    return map[portion] || (portion || '—');
  }

  function formatPortionShort(portion) {
    var map = { light: 'Light', daily: 'Daily', boost: 'Boost' };
    return map[portion] || (portion || '—');
  }

  // =========================================
  // SUBMIT → PANIER SHOPIFY
  // =========================================
  function initNewsletterRecap() {
    var btn = document.getElementById('newsletter-recap-btn');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var emailEl = document.getElementById('newsletter-recap-email');
      var email = emailEl ? emailEl.value.trim() : '';
      if (!email || !email.includes('@')) {
        emailEl && emailEl.focus();
        return;
      }
      btn.disabled = true;
      btn.textContent = '...';

      fetch('/contact#contact_form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          'form_type': 'contact',
          'utf8': '✓',
          'contact[email]': email,
          'contact[name]': 'Newsletter -10€',
          'contact[tags]': 'newsletter,newsletter-10eur',
          'contact[body]': 'Inscription newsletter depuis tunnel abonnement. Email: ' + email
        }).toString()
      })
      .finally(function() {
        document.getElementById('fueled-newsletter-recap-form').style.display = 'none';
        document.getElementById('fueled-newsletter-success').style.display = 'block';
      });
    });
  }

  function initSubmit() {
    var submitBtn = document.getElementById('submit-subscription');
    if (!submitBtn) return;
    submitBtn.addEventListener('click', handleSubmit);
  }

  function handleSubmit() {
    var submitBtn = document.getElementById('submit-subscription');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Chargement...';

    var mealsData = window.fueledMeals || {};
    var allMeals = [].concat(mealsData.menu || [], mealsData.classics || [], mealsData.bagels || []);

    function getVariantId(mealId, portion) {
      var meal = allMeals.find(function(m) { return m.id === mealId; });
      if (!meal) return null;
      if (meal.variants) {
        var key = (portion || 'daily').toLowerCase();
        return meal.variants[key] || meal.variants.daily || meal.variants.light || Object.values(meal.variants)[0];
      }
      return meal.variantId || null;
    }

    var itemsToAdd = [];
    var sellingPlanId = 692042826076;
    var baseProps = {
      '_subscription': 'true',
      '_zone': state.zone ? state.zone.name : '',
      '_delivery_day': state.deliveryDay || '',
      '_delivery_slot': state.deliverySlot || '',
      '_postal_code': state.postalCode ? state.postalCode.toString() : ''
    };

    if (state.orderType === 'solo') {
      state.selectedMeals.forEach(function(meal) {
        var variantId = getVariantId(meal.id, state.portion);
        if (variantId) {
          itemsToAdd.push({
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlanId,
            properties: Object.assign({}, baseProps, { '_portion': state.portion })
          });
        }
      });
    } else {
      state.selectedMealsPerson1.forEach(function(meal) {
        var variantId = getVariantId(meal.id, state.portion1);
        if (variantId) {
          itemsToAdd.push({
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlanId,
            properties: Object.assign({}, baseProps, { '_person': '1', '_portion': state.portion1 })
          });
        }
      });
      state.selectedMealsPerson2.forEach(function(meal) {
        var variantId = getVariantId(meal.id, state.portion2);
        if (variantId) {
          itemsToAdd.push({
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlanId,
            properties: Object.assign({}, baseProps, { '_person': '2', '_portion': state.portion2 })
          });
        }
      });
    }

    if (itemsToAdd.length === 0) {
      alert('Erreur : aucun plat valide sélectionné');
      submitBtn.disabled = false;
      submitBtn.textContent = 'Démarrer mon abonnement 🚀';
      return;
    }

    fetch('/cart/clear.js', { method: 'POST' })
    .then(function() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      });
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Erreur panier: ' + response.status);
      return response.json();
    })
    .then(function() {
      window.location.href = '/checkout?return_url=' + encodeURIComponent('/account/register');
    })
    .catch(function(error) {
      console.error('Erreur handleSubmit:', error);
      alert('Une erreur est survenue. Merci de réessayer.');
      submitBtn.disabled = false;
      submitBtn.textContent = 'Démarrer mon abonnement 🚀';
    });
  }

  // =========================================
  // BOOT
  // =========================================
  // Vider le panier dès le chargement de la page tunnel
  fetch('/cart/clear.js', { method: 'POST' }).catch(function() {});

  // Forcer le rafraîchissement du mini-cart du thème Flow
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      // Déclencher l'événement natif Flow pour mettre à jour l'icône panier
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:update', { bubbles: true }));
      // Mise à jour manuelle du compteur panier si Flow l'expose
      var cartCount = document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count');
      cartCount.forEach(function(el) {
        el.textContent = cart.item_count || 0;
        if (cart.item_count === 0) el.style.display = 'none';
      });
    })
    .catch(function() {});

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
